import {Component, Input, OnInit} from '@angular/core';
import {TaskJobDto, TaskJobListDto} from '../../../../models/server/DataTransferObject/Objects/TaskJobs';
import {ModalController} from '@ionic/angular';

@Component({
    selector: 'app-tasks-job-confirm',
    templateUrl: './tasks-job-confirm.component.html',
    styleUrls: ['./tasks-job-confirm.component.scss'],
})
export class TasksJobConfirmComponent {

    @Input() public job: TaskJobDto;

    constructor(
        protected modalCtrl: ModalController
    ) {

    }
    async confirm() {
        await this.modalCtrl.dismiss({
            isConfirmed: true
        });
    }

    async exit() {
        await this.modalCtrl.dismiss({
            isConfirmed: false
        });
    }
}
